import { useTranslation } from 'react-i18next';

export const ProductTableHeader = () => {
  const { t } = useTranslation();

  return (
    <tr className="bg-base-200">
      <th className="w-8">
        <label>
          <input type="checkbox" className="checkbox" />
        </label>
      </th>
      <th>{t('products.table.product')}</th>
      <th>{t('products.table.code')}</th>
      <th>{t('products.table.status')}</th>
      <th>{t('products.table.price')}</th>
      <th>{t('products.table.actions')}</th>
    </tr>
  );
}; 